var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-alerts"},_vm._l((_vm.alerts),function(alert){return _c('alerts-item',{key:alert.id,attrs:{"alert":alert}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }